import { createContext, useState } from 'react';

const BatchListContext = createContext({
  dataState: {
    items: [],
    total: 0,
    pageCount: 0,
    loading: false,
    status: 'idle',
  },
  updateDataState: () => {},
});

export const BatchListContextProvider = ({ children }) => {
  const [dataState, setDataState] = useState({
    items: [],
    total: 0,
    pageCount: 0,
    loading: false,
    status: 'idle',
  });

  const updateDataState = (newState) => {
    setDataState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };

  const context = {
    dataState,
    updateDataState,
  };

  return (
    <BatchListContext.Provider value={context}>
      {children}
    </BatchListContext.Provider>
  );
};

export default BatchListContext;
